export async function parseJson(res) {
  const text = await res.text();
  if (text.trim().startsWith("<")) {
    return { message: "Server Error: An unexpected issue occurred." };
  }
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

function messageForResponse(res, payload, fallback) {
  if (res.status >= 500) {
    return "Internal server error. Please try again later.";
  }
  const m = payload?.message;
  return typeof m === "string" && m.trim() ? m : fallback;
}

export function buildApiError(res, payload, fallback) {
  const error = new Error(messageForResponse(res, payload, fallback));
  if (payload && typeof payload === "object") {
    error.details = payload.details || {};
    error.payload = payload;
  }
  error.status = res.status;
  return error;
}

export function authJsonHeaders(csrfToken, extra = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...extra,
  };
  if (csrfToken) headers["X-CSRF-Token"] = csrfToken;
  return headers;
}

/** Rows usable on form dropdowns (`is_active` + business `status_id`). */
export function filterActiveMasterRows(rows) {
  return (rows || []).filter((row) => {
    if (!row) return false;
    if (Number(row.is_active) === 2) return false;
    const status = row.status_id != null && row.status_id !== "" ? Number(row.status_id) : 1;
    if (status === 0) return false;
    return true;
  });
}
